import { createAction } from 'redux-actions';

export const clearIventoryTags = createAction('CLEAR_INVENTORY_TAGS');

export const inventoryTagsOnChangePage = createAction(
  'INVENTORY_TAGS_ON_CHANGE_PAGE'
);

export const inventoryTagsOnChangeOrder = createAction(
  'INVENTORY_TAGS_ON_CHANGE_ORDER'
);
